import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-364a84ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Overview")
const _hoisted_2 = ["innerHTML"]

import { Node } from "@/api/node-lookup";
import AppDetails from "@/components/AppDetails.vue";
import AppDetail from "@/components/AppDetail.vue";

interface Props {
  /** current node */
  node: Node;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SectionOverview',
  props: {
    node: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_AppHeading = _resolveComponent("AppHeading")!
  const _component_AppSection = _resolveComponent("AppSection")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_AppSection, null, {
    default: _withCtx(() => [
      _createVNode(_component_AppHeading, { icon: "lightbulb" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(AppDetails, null, {
        default: _withCtx(() => [
          _createVNode(AppDetail, {
            blank: !__props.node.synonyms.length,
            title: "Also Known As"
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(__props.node.synonyms.join(" | ")), 1)
            ]),
            _: 1
          }, 8, ["blank"]),
          (__props.node.category === 'gene')
            ? (_openBlock(), _createBlock(AppDetail, {
                key: 0,
                blank: !__props.node.symbol,
                title: "Symbol"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(__props.node.symbol), 1)
                ]),
                _: 1
              }, 8, ["blank"]))
            : _createCommentVNode("", true),
          (__props.node.category === 'publication')
            ? (_openBlock(), _createBlock(AppDetail, {
                key: 1,
                blank: !__props.node.authors?.length,
                title: "Authors"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(__props.node.authors?.join(", ")), 1)
                ]),
                _: 1
              }, 8, ["blank"]))
            : _createCommentVNode("", true),
          _createVNode(AppDetail, {
            blank: !__props.node.description,
            title: "Description",
            big: true
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("p", {
                class: "description truncate-10",
                tabindex: "0",
                innerHTML: __props.node.description.trim()
              }, null, 8, _hoisted_2), [
                [_directive_tooltip, 'Click to expand']
              ])
            ]),
            _: 1
          }, 8, ["blank"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})